import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import CTSUErrorBoundary from 'components/ErrorBoundary';
import { CTSULoadingError, CTSULoadingSpinner } from 'components';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  paperRender: {
    margin: theme.spacing(1),
    textAlign: 'center',
    color: '#000' // theme.palette.primary.dark
  }
}));

const RenderComponent = ({
  isLoading, iserror, compName, children, permission
}) => {
  const classes = useStyles();

  if (iserror) {
    return (
      <CTSULoadingError compName={compName} />
    );
  }

  if (permission === true) {
    return (
      <Fade in timeout={2000}>
        <div className={classes.paperRender}>
          {isLoading === true
          && <CTSULoadingSpinner />}
          {children}
        </div>
      </Fade>
    );
  }
  return (
    <h3>
      You do not have permission to access -
      {' '}
      {compName}
    </h3>
  );
};


const RenderControl = props => (
  <CTSUErrorBoundary>
    <RenderComponent {...props} />
  </CTSUErrorBoundary>
);


export { RenderControl };
